export const handleClickOutside = (event: MouseEvent, callback: Function, anchor: any, filtering: boolean) => {
  if (anchor.current && !anchor.current.contains(event.target as Node) && filtering) {
    callback()
  }
}
